import type { EHRAppointment, ScheduleItem } from '@heidi/integrations/ehr/contracts';

/** Type guard — `EHRAppointment` carries `record_id` and `patient_id`; schedule items do not. */
export function isEHRAppointment(
  item: EHRAppointment | ScheduleItem
): item is EHRAppointment {
  return 'record_id' in item && 'patient_id' in item;
}
